import React from "react";


function Index() {

  window.location.href = process.env.REACT_APP_GAME_DOWNLOAD_LINK;
  return (
      <div></div>
  );
}

export default Index;
